module.exports = __webpack_public_path__ + "static/media/starOff_118.4f332d0d.png";